import React, { useState } from 'react';
import { Accordion } from 'react-bootstrap';
import PropTypes from 'prop-types';

import TractComparisonCard from './TractComparisonCard';

/**
 * CommunityPicture
 * Section wrapper for the "who lives nearby" comparison: a title, intro,
 * methodology/margin-of-error note, a single-select accordion of
 * per-facility comparison cards, and a source citation.
 */
export default function CommunityPicture({ data }) {
    const { title, intro, methodologyNote, source, facilities } = data;
    const [activeKey, setActiveKey] = useState(facilities[0]?.name ?? null);

    return (
        <>
            <h3 className="section-title fw-semibold mb-3">{title}</h3>
            <p className="section-description fs-5 mb-3">{intro}</p>
            <p className="small text-muted mb-4">{methodologyNote}</p>

            <Accordion
                activeKey={activeKey}
                onSelect={setActiveKey}
                className="mb-4"
            >
                {facilities.map((facility) => (
                    <TractComparisonCard
                        key={facility.name}
                        facility={facility}
                        eventKey={facility.name}
                    />
                ))}
            </Accordion>

            <a
                href={source.url}
                target="_blank"
                rel="noopener noreferrer"
                className="why-stat-source"
            >
                {source.name}
            </a>
        </>
    );
}

CommunityPicture.propTypes = {
    data: PropTypes.shape({
        title: PropTypes.string.isRequired,
        intro: PropTypes.string.isRequired,
        methodologyNote: PropTypes.string.isRequired,
        source: PropTypes.shape({
            name: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
        }).isRequired,
        facilities: PropTypes.arrayOf(PropTypes.object).isRequired,
    }).isRequired,
};
